
/**
 * Check if a string is a valid UUID
 * @param uuid String to check
 * @returns Boolean indicating if the string is a valid UUID
 */
export function isValidUUID(uuid: string): boolean {
  if (!uuid) return false;
  const uuidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
  return uuidRegex.test(uuid);
}

/**
 * Retrieve the currently stored user id and validate it.
 *
 * @returns The UUID if valid, otherwise `null`.
 */
export function getValidUserId(): string | null {
  const id = localStorage.getItem('userId');
  return id && isValidUUID(id) ? id : null;
}
